__turbopack_context__.v({
  "cart": "company-legal-notice-module__nKCPiW__cart",
  "checkout": "company-legal-notice-module__nKCPiW__checkout",
  "footer": "company-legal-notice-module__nKCPiW__footer",
  "identity": "company-legal-notice-module__nKCPiW__identity",
  "name": "company-legal-notice-module__nKCPiW__name",
  "notice": "company-legal-notice-module__nKCPiW__notice",
  "taxStatement": "company-legal-notice-module__nKCPiW__taxStatement",
});
